query acaoSelect {
    data: acoesAll(order: [{nome: ASC}]) {
        value: codigo
        label: nome
    }
}